import { initContract } from '@ts-rest/core';
import { z } from 'zod';
import { PaymentDecision } from '../../data/claims-decision/payment-decision/data.js';
////////////////////////////////////////////////////////////////////////////////
// getPaymentDecisionDocument
////////////////////////////////////////////////////////////////////////////////
const [authorizationDocument, settlementDocument, denialDocument] = PaymentDecision.shape.documents.element.options;
/**
 * What no reporter or broker may read of a Beleg: the note clerks and the claim agent write for each other, and
 * the document of the Akte the Beleg was read from.
 */
const INTERNAL_DOCUMENT_FIELDS = { internalNote: true, documentReference: true };
/** The account of a payout as the portal names it: by holder and IBAN, without the ids of the OASIS records. */
const PortalBankAccount = settlementDocument.shape.bankAccount.unwrap().omit({ personId: true, bankAccountId: true });
/** A Beleg as the portal receives it: the stored Beleg without its internal fields and record ids. */
const PortalPaymentDecisionDocument = z.discriminatedUnion('decision', [
    authorizationDocument.omit(INTERNAL_DOCUMENT_FIELDS),
    settlementDocument
        .omit({ ...INTERNAL_DOCUMENT_FIELDS, accountingRecordId: true })
        .extend({ bankAccount: PortalBankAccount.nullable() }),
    denialDocument.omit(INTERNAL_DOCUMENT_FIELDS),
]);
export const GetPaymentDecisionDocumentResponse = z.strictObject({
    document: PortalPaymentDecisionDocument,
    /** Whether the AI released the decision; decides how a provisional authorization is explained. */
    approvedByAi: z.boolean(),
});
////////////////////////////////////////////////////////////////////////////////
// contract
////////////////////////////////////////////////////////////////////////////////
const c = initContract();
export const paymentDecisionDocumentContract = c.router({
    getDocument: {
        method: 'GET',
        path: '/get-document/:paymentDecisionId/:documentIndex',
        pathParams: z.strictObject({
            paymentDecisionId: z.string(),
            documentIndex: z.string(),
        }),
        responses: {
            200: GetPaymentDecisionDocumentResponse,
        },
    },
}, { strictStatusCodes: true, pathPrefix: '/payment-decision-document' });
